<template>
  <div class="wrapper">
    <div class="topWrapper">
      <div class="logoWrapper">
        <img src="../../assets/icons/logo.png" class="logoImg">
      </div>
      <div class="versionInfo">i襄阳 {{currentVersion}}</div>
    </div>
    <van-cell-group>
      <!-- <van-cell title="昵称" is-link :value="nikeName" @click="gotoModifyNikeName"/> -->
      <!-- <van-cell title="更新检测" @click="alertVersionInfo"/> -->
      <van-cell title="用户隐私政策" is-link @click="gotoProtocl"/>
      <van-cell title="用户服务协议" is-link @click="gotoSupport"/>
    </van-cell-group>
    <div class="cell-divider"></div>
    <!-- <van-cell-group>
      <van-cell title="认证级别">
        <template slot="default">
          <span class="custom-value">{{authLevel}}</span>
          <van-tag color="#f2826a" plain>升级认证</van-tag>
        </template>
      </van-cell>
    </van-cell-group>-->
    <!-- <van-dialog
      v-model="showDg"
      :confirmButtonText="confirmButtonText"
      title="标题"
      show-cancel-button
    >{{updateInfo}}</van-dialog>-->
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup } from "vant";
import { Tag } from "vant";
import checkAJB from "../../utils/checkAlipayJSBridge.js";
import { mapGetters } from "vuex";
import { searchPerLegalDetail } from "@/api/user";
import CommonFunc, { judgeClientType } from "../../utils/CommonFun.js";
import { getReleaseInfo } from "../../api/user";
import { Dialog } from "vant";
Vue.use(Dialog);
Vue.use(Tag);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
  data() {
    return {
      currentVersion: "暂无版本信息",
      updateInfo: "已经是最新版啦",
      freshUrl: "",
      isLastest: false,
      showDg: false,
      confirmButtonText: "确认"
    };
  },
  async created() {
    this.getCurrentVersion();
  },
  computed: {},
  methods: {
    async getCurrentVersion() {
      let appType = "";
      let currentType = judgeClientType();
      if (currentType == "ios") {
        appType = 1;
      } else if (currentType == "android") {
        appType = 0;
      }
      let appInfo = await checkAJB.getAppInfo();
      this.currentVersion = appInfo.version;
      let build = appInfo.build;
      let appId = appInfo.appId;
      let res = await getReleaseInfo({
        appId: appId,
        appType: appType
      });
      console.log(res, "resss");
      if ((res.respCode = "00000000")) {
        let latestBuild = res.respData.build;
        if (latestBuild != build) {
          this.isLastest = true;
        }
        this.updateInfo = res.respData.releaseNotes;
        this.freshUrl = res.respData.downLoadUrl;
      }
    },
    alertVersionInfo() {
      let isLast = this.isLastest;
      let confirmButtonText = "确认";
      if (isLast) {
        //需要去更新
        confirmButtonText = "去更新";
      } else {
        //当前已是最新
        this.updateInfo = "当前已是最新版本";
      }
      Dialog.confirm({
        title: "检测更新",
        message: this.updateInfo,
        confirmButtonColor: "#1989fa",
        confirmButtonText: confirmButtonText
      })
        .then(() => {
          if (isLast) {
            window.open(this.freshUrl);
          } else {
          }
        })
        .catch(() => {});
    },
    gotoProtocl() {
      // checkAJB.toast("暂时没有协议哟(＾Ｕ＾)ノ~ＹＯ");
      this.$router.push({
        name: "privateProtocol"
      });
    },
    gotoSupport() {
      this.$router.push({
        name: "supportProtocol"
      });
    },
    gotoVersion() {
      this.$router.push({
        name: "appVersion"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .topWrapper {
    padding: 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center; /*由于flex-direction: column，因此align-items代表的是水平方向*/
    justify-content: center;
    .logoWrapper {
      .logoImg {
        width: 72px;
        height: 72px;
        border-radius: 1.5rem;
      }
    }
    .versionInfo {
      margin-top: 8px;
      color: #999;
      font-size: 13px;
    }
  }
  .custom-value {
    margin-right: 8px;
  }
}
</style>